import axios from "axios";

const state = {
    /** @type {Array<Object>} */
    notifications: [],
    /** @type {number} */
    unreadCount: 0,
    /** @type {boolean} */
    loading: false,
    /** @type {boolean} */
    panelOpen: false,
};

const getters = {
    hasUnread: (state) => state.unreadCount > 0,
};

const mutations = {
    setNotifications(state, notifications) {
        state.notifications = notifications;
    },
    setUnreadCount(state, count) {
        state.unreadCount = count;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setPanelOpen(state, open) {
        state.panelOpen = open;
    },
    markNotificationRead(state, notifId) {
        const n = state.notifications.find((x) => x.id === notifId);
        if (n && !n.is_read) {
            n.is_read = true;
            n.read_at = new Date().toISOString();
            state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
    },
    markAllRead(state) {
        state.notifications.forEach((n) => {
            n.is_read = true;
            n.read_at = n.read_at || new Date().toISOString();
        });
        state.unreadCount = 0;
    },
};

const actions = {
    async fetchUnreadCount({ commit }) {
        try {
            const { data } = await axios.get("/api/notifications/inapp/unread-count/");
            commit("setUnreadCount", data.count);
        } catch {
            // silent
        }
    },

    async fetchNotifications({ commit }) {
        commit("setLoading", true);
        try {
            const { data } = await axios.get("/api/notifications/inapp/?limit=30");
            commit("setNotifications", data.results || data);
        } catch {
            // silent
        } finally {
            commit("setLoading", false);
        }
    },

    async markRead({ commit }, notifId) {
        commit("markNotificationRead", notifId);
        try {
            await axios.post(`/api/notifications/inapp/${notifId}/mark-read/`);
        } catch {
            // silent
        }
    },

    async markAllRead({ commit }) {
        commit("markAllRead");
        try {
            await axios.post("/api/notifications/inapp/mark-all-read/");
        } catch {
            // silent
        }
    },

    togglePanel({ commit, state, dispatch }) {
        const willOpen = !state.panelOpen;
        commit("setPanelOpen", willOpen);
        if (willOpen) {
            dispatch("fetchNotifications");
            dispatch("fetchUnreadCount");
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
